require("jquery");define(['angular-dontrequire', 'lodash'], function (angular, _) {
    var bootstrap = angular.bootstrap;
    angular.bootstrap = function (element, modules, config) {
        try {
            return bootstrap.call(this, element, modules, _.defaults({strictDi: true}, config));
        } catch (e) {
            var message = _.get(e, 'message', '');
            throw _(message.split('\n'))
                .reject(function (line) {
                    return line.indexOf('http://errors.angularjs.org') === 0;
                })
                .join('\n');
        }
    };
    return angular;
});
